import { render, staticRenderFns } from "./StudentsEditDataFamily.vue?vue&type=template&id=c6e56a64&scoped=true&"
import script from "./StudentsEditDataFamily.vue?vue&type=script&lang=js&"
export * from "./StudentsEditDataFamily.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEditDataFamily.vue?vue&type=style&index=0&id=c6e56a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e56a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VContainer,VForm,VRow,VSelect,VTextField,VTextarea})
